import React from 'react';

import {
  Box,
  SectionTitle,
  MaterialIcons,
  Paper,
} from '@iclinic/design-system';
import ComplaintInput from './ComplaintInput';
import ComplaintsList from './ComplaintsList';
import Suggestions from './Suggestions';

const { RecordVoiceOver } = MaterialIcons;

const ComplaintsContainer = () => {
  return (
    <Box mb={3}>
      <Paper elevation={1}>
        <Box mb={3}>
          <SectionTitle title="Queixa e duração" icon={<RecordVoiceOver />} />
        </Box>

        <Box mb={2}>
          <Suggestions />
        </Box>

        <Box>
          <ComplaintInput />
        </Box>

        <ComplaintsList />
      </Paper>
    </Box>
  );
};

export default ComplaintsContainer;
